import { createContext, useContext } from 'react';

import { TenantRegionalSettings } from '../../singleton/tenant-settings-manager';

export type TenantRegionalSettingsContextValue = {
  settings: TenantRegionalSettings;
  applySettings: (settings: TenantRegionalSettings) => void;
};

export const TenantRegionalSettingsContext =
  createContext<TenantRegionalSettingsContextValue | null>(null);

export const useTenantRegionalSettings = () => {
  const context = useContext(TenantRegionalSettingsContext);
  if (!context) {
    throw new Error(
      'useTenantRegionalSettings must be used within TenantSettingsProvider'
    );
  }
  return context;
};
